module.exports = {
	"id": "BI",
	"name": "Burundi",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.022464,
			"9": null,
			"10": 0.001664,
			"11": 0.009152,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.000832,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.010816,
			"27": 0.001664,
			"28": 0.000832,
			"29": 0.014144,
			"30": 0.003328,
			"31": 0.00416,
			"32": 0.001664,
			"33": 0.000832,
			"34": 0.00416,
			"35": 0.001664,
			"36": 0.001664,
			"37": 0.001664,
			"38": 0.004992,
			"39": 0.002496,
			"40": 0.00416,
			"41": 0.003328,
			"42": 0.003328,
			"43": 0.081536,
			"44": 0.001664,
			"45": 0.024128,
			"46": 0.001664,
			"47": 0.009152,
			"48": 0.003328,
			"49": 0.069888,
			"50": 0.00832,
			"51": 0.03328,
			"52": 0.024128,
			"53": 2.108288,
			"54": 0.563264,
			"55": 0.00416,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.005824,
			"3": 0.0624,
			"4": 0.003328,
			"5": 0.00416,
			"6": null,
			"7": 0.00832,
			"8": 0.002496,
			"9": 0.022464,
			"10": 0.011648,
			"11": 0.024128,
			"12": 0.010816,
			"13": 0.003328,
			"14": 0.001664,
			"15": 0.007488,
			"16": 0.00832,
			"17": 0.00416,
			"18": 0.003328,
			"19": 0.003328,
			"20": 0.009984,
			"21": 0.002496,
			"22": 0.002496,
			"23": 0.007488,
			"24": 0.013312,
			"25": 0.002496,
			"26": 0.006656,
			"27": 0.001664,
			"28": 0.011648,
			"29": 0.005824,
			"30": 0.057408,
			"31": 0.064896,
			"32": 0.01248,
			"33": 0.009984,
			"34": 0.005824,
			"35": 0.00832,
			"36": 0.017472,
			"37": 0.026624,
			"38": 0.011648,
			"39": 0.006656,
			"40": 0.01248,
			"41": 0.014144,
			"42": 0.005824,
			"43": 0.13312,
			"44": 0.040768,
			"45": 0.039936,
			"46": 0.054912,
			"47": 0.286208,
			"48": 0.205504,
			"49": 1.74304,
			"50": 0.239616,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.060736
		},
		"opera": {
			"9": null,
			"11": 0.002496,
			"12": null,
			"15": 0.003328,
			"16": null,
			"17": null,
			"18": 0.001664,
			"19": null,
			"20": null,
			"21": 0.004992,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.00416,
			"30": 0.002496,
			"31": null,
			"32": null,
			"33": 0.034112,
			"34": 0.009984,
			"35": 0.022464,
			"36": 0.010816,
			"37": 0.182208,
			"38": 0.00416,
			"39": 0.009984,
			"40": 0.156416,
			"41": 0.013312,
			"42": null,
			"43": null,
			"9.5-9.6": 0.002496,
			"10.0-10.1": 0.000832,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.001664,
			"12.1": 0.004992
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.001664,
			"6": null,
			"7": null,
			"8": 0.009152,
			"9": 0.018304,
			"10": 0.03328,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006656,
			"6.1": 0.005824,
			"7.1": 0.001664,
			"9.1": 0.026624
		},
		"ios_saf": {
			"8": 0,
			"10": 0.332198748543,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0089523718776,
			"8.1-8.4": 0.0165391277061,
			"9.0-9.2": 0.00789022606162,
			"9.3": 0.120376525812
		},
		"android": {
			"3": 0,
			"4": 0.0363206124031,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00454007655039,
			"4.1": 0.131013637597,
			"4.2-4.3": 0.327534093992,
			"4.4": 0.751058377907,
			"4.4.3-4.4.4": 0.75754420155
		},
		"ie": {
			"6": 0.00166807343941,
			"7": 0.00500422031824,
			"8": 0.145956425949,
			"9": 0.0308593586291,
			"10": 0.0633867906977,
			"11": 0.434533130967,
			"5.5": null
		},
		"op_mob": {
			"0": 5.52077277241,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.153354799234
		},
		"edge": {
			"12": 0.019968,
			"13": 0.076544,
			"14": 0.032448
		},
		"ie_mob": {
			"10": 0.0650869859155,
			"11": 0.264997014085
		},
		"bb": {
			"7": 0.0137535,
			"10": null
		},
		"samsung": {
			"0": 0.403436
		},
		"and_uc": {
			"0": 1.916321
		},
		"op_mini": {
			"0": 74.3804114284
		},
		"and_chr": {
			"0": 5.67741
		},
		"and_ff": {
			"0": 0.009169
		}
	},
	"total": 98.6254645
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BI.json
 ** module id = 478
 ** module chunks = 0
 **/